// components/ToolsSection.jsx
import { Container, Typography, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ToolCard from './ToolCard';
import PeopleIcon from '@mui/icons-material/People';
import VerifiedIcon from '@mui/icons-material/Verified';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import DashboardIcon from '@mui/icons-material/Dashboard';

import ShieldIcon from '@mui/icons-material/Shield';

const ToolsSection = () => {
    const navigate = useNavigate();

    const tools = [
        // {
        //     icon: <PeopleIcon sx={{ fontSize: 32, color: 'white' }} />,
        //     title: 'Community Flagging System',
        //     description: 'Flag content and see what others think too. Learn with help from a more knowledgeable community.',
        //     color: '#ba68c8',
        //     onClick: () => { }, // Add route later
        // },
        {
            icon: <DashboardIcon sx={{ fontSize: 32, color: 'white' }} />,
            title: 'Your Personal Dashboard',
            description: 'Check your Course progress and Compare your quiz results...',
            color: '#094487',
            onClick: () => navigate('/personal-dashboard'),
        },
        {
            icon: <VerifiedIcon sx={{ fontSize: 32, color: 'white' }} />,
            title: 'Real-Time Credibility Checker',
            description: 'Scan any website as you browse and instantly see trust scores...',
            color: '#66bb6a',
            onClick: () => navigate('/quick-check'),
        },
        {
            icon: <LightbulbIcon sx={{ fontSize: 32, color: 'white' }} />,
            title: 'Misinformation Susceptibility Quiz',
            description: 'Find out how vulnerable you are to misinformation...',
            color: '#f06292',
            onClick: () => navigate('/quiz'),
        },
        {
            icon: <MenuBookIcon sx={{ fontSize: 32, color: 'white' }} />,
            title: 'Educational Modules',
            description: 'Interactive videos and quizzes tailored to you.',
            color: '#5c6bc0',
            onClick: () => navigate('/education'),
        },
        {
            icon: <ShieldIcon sx={{ fontSize: 32, color: 'white' }} />,
            title: 'Ctrl Alt Debunk',
            description: 'Defend against the Elusive Echo by Debunking it!',
            color: '#26a69a',
            onClick: () => navigate('/defence-game'),
        },
    ];

    return (
        <Container maxWidth="lg" sx={{ py: 6 }}>
            <Typography variant="h2" align="center" gutterBottom sx={{ color: 'white', fontWeight: 'bold' }}>
                Explore Our Tools
            </Typography>
            <Typography variant="h4" align="center" sx={{ mb: 6, color: 'white', opacity: 0.9 }}>
                Choose a tool to start learning, checking, or leveling up your digital confidence!
            </Typography>

            <Grid container spacing={3} justifyContent="center">
                {tools.map((tool, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index} sx={{ width: '30%' }}>
                        <ToolCard {...tool} />
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};

export default ToolsSection;
